<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>Ferro Sérico (µg/dL)</label>
          <md-input
            id="serumIron"
            v-model="exam.fields.serumIron"
            v-validate="'required'"
            v-mask="`###`"
            data-vv-validate-on="none"
            name="serumIron"
            title="Ferro Sérico (µg/dL)"
            placeholder="Ferro Sérico (µg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.serumIron"
            v-mask="`###`"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>CTLF (µg/dL)</label>
          <md-input
            id="ironBond"
            v-model="exam.fields.ironBond"
            v-validate="'required'"
            v-mask="`###`"
            data-vv-validate-on="none"
            name="ironBond"
            title="CTLF (µg/dL)"
            placeholder="CTLF (µg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.ironBond"
            v-mask="`###`"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>
    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}%</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalcIndiceSaturacaoTransferrina',

  data: () => {
    return {
      exam: {
        fields: {
          serumIron: null,
          ironBond: null
        },
        result: 0
      }
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.serumIron && this.exam.fields.ironBond) {
        const serumIron = +this.exam.fields.serumIron
        const ironBond = +this.exam.fields.ironBond

        this.exam.result = ((serumIron / ironBond) * 100).toFixed(2)
      }
    }
  }
}
</script>

